import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import Flag from 'react-flags';
import profileIcon from '../img/profile.png';
import withTracker from "../containers/Full/withTracker";
import {withRouter, Link } from "react-router-dom";
import {connect} from "react-redux";
import RequestForm from "./RequestForm";
import ReviewForm from "./ReviewForm";
import chatIcon from "../img/chaticon.png";
import Swal from "sweetalert2";

import {update} from '../modules/actions/request';


class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            isReview2: false,
        };

        this.toggleForm = this.toggleForm.bind(this);
    }

    toggleForm(){
        this.setState({
            showForm: !this.state.showForm
        })
    }

    async updateHandler(requestId, status){
        // console.log("requestId", requestId);
        var payload = {"requestId": requestId , "status": status};
        let result = await this.props.dispatch(update(payload));
        if(result.status==="Success"){
            Swal.fire({
                title: 'Success!',
                text: 'Successfully cancelled. If you want to reschedule, submit request again.',
                type: 'success',
                confirmButtonText: 'close'
            })
                .then(()=>{
                    console.log("Dismissed");
                    window.location.assign('/dashboard/schedule');
                });
        }
        // console.log("what is request??", result);
    }

    render() {
        // console.log("this props schedule", this.props.schedule);
        // console.log("this props", this.props);
        const { date, userName, topic, photoUrl, isBuyerReviewed, isSellerReviewed, requestId } = this.props.schedule || {};
        const type = this.props.type || 'schedule';
        // console.log("type", type);
        // console.log("is reviewed", isReviewed);

                return (
            <div className="col-sm-6 col-md-4">
                <div className="country-card-container border-gray rounded border mx-2 my-3 d-flex flex-row align-items-center p-0 bg-light">

                    <div className="h-100 position-relative border-gray border-right px-2 bg-white rounded-left">

                        {/*<Flag country={code2} format="png" pngSize={64} basePath="./img/flags" className="d-block img-center" width={96} height={96} />*/}

                        <img src={photoUrl ? photoUrl : profileIcon} format="png" pngSize={64} className="d-block img-center" width={96} height={96} />
                    </div>

                    <div className="px-3">

                        {/*<span className="country-name text-dark d-block font-weight-bold">Name: { name.common }</span>*/}
                        {/*<span className="country-name text-dark d-block font-weight-bold">Name: { name.official }</span>*/}
                        {/*<span className="country-region text-secondary text-uppercase">{ region }</span>*/}
                        <span className="country-region text-secondary d-block text-uppercase">Name: {userName}</span>
                        {/*<span className="country-region text-secondary d-block text-uppercase">type: {type}</span>*/}
                        <span className="country-region text-secondary d-block text-uppercase">Date: {date.split('T')[0]}
                            {/*{moment(date).format("MMM DD,YYYY")}*/}
                        </span>
                        <span className="country-region text-secondary d-block text-uppercase">Topic: {topic}</span>
                        {/*<span className="country-region text-secondary d-block text-uppercase">Goes to detail page</span>*/}
                        <Link className="btn-back" to ={'/dashboard/profile/'+userName}>Go to detail page </Link>

                        {(type === 'history') ?
                            (this.props.user.type === "Buyer" ?
                                    (!isSellerReviewed?
                                            <span>
                                    <button style={{"position": "absolute", "right": "5px", "bottom" : "5px"}}
                                            onClick={this.toggleForm}> Review </button>
                                                {this.state.showForm ?
                                                    <ReviewForm closeForm={this.toggleForm} request={this.props.schedule} userName={userName}
                                                    /> : null}
                                </span>
                                            :
                                            <span style={{"position": "absolute", "right": "5px", "bottom" : "5px", "color": "green"}}>Review submitted</span>
                                    ):
                                    (!isBuyerReviewed?
                                            <span>
                                    <button style={{"position": "absolute", "right": "5px", "bottom" : "5px"}}
                                            onClick={this.toggleForm}> Review </button>
                                                {this.state.showForm ?
                                                    <ReviewForm closeForm={this.toggleForm} request={this.props.schedule} userName={userName}
                                                    /> : null}
                                </span>
                                            :
                                            <span style={{"position": "absolute", "right": "5px", "bottom" : "5px", "color": "green"}}>Review submitted</span>
                                    )

                            )

                            :
                        <span>
                            <Link
                                to = {'/dashboard/chat/'+requestId}
                            >
                                {/*<img src={chatIcon}*/}
                                {/*     style={{*/}
                                {/*         "position": "absolute",*/}
                                {/*         "left": "50%", "bottom" : "5px",*/}
                                {/*         "width":"35px", "height":"35px"}}/>*/}
                            </Link>
                            {/*<button style={{"position": "absolute", "right": "180px", "bottom" : "5px"}}>  Chat </button>*/}
                            <button
                                style={{"position": "absolute", "right": "5px", "bottom" : "5px"}}
                                onClick={()=>this.updateHandler((requestId), "Rejected")}
                            > Cancel / Reschedule </button>
                        </span>
                        }

                    </div>

                </div>
            </div>
        )
        }

}


//new format
// const Card = props => {
//     const { date  , buyerName } = props.schedule || {};
//     const type = props.type || 'schedule';
//     console.log("type", type);
//
//     this.state = {
//
//     }
//
//     return (
//         <div className="col-sm-6 col-md-4">
//             <div className="country-card-container border-gray rounded border mx-2 my-3 d-flex flex-row align-items-center p-0 bg-light">
//
//                 <div className="h-100 position-relative border-gray border-right px-2 bg-white rounded-left">
//
//                     {/*<Flag country={code2} format="png" pngSize={64} basePath="./img/flags" className="d-block img-center" width={96} height={96} />*/}
//
//                     <img src={image} format="png" pngSize={64} className="d-block img-center" width={96} height={96} />
//                 </div>
//
//                 <div className="px-3">
//
//                     {/*<span className="country-name text-dark d-block font-weight-bold">Name: { name.common }</span>*/}
//                     {/*<span className="country-name text-dark d-block font-weight-bold">Name: { name.official }</span>*/}
//                     {/*<span className="country-region text-secondary text-uppercase">{ region }</span>*/}
//                     <span className="country-region text-secondary d-block text-uppercase">Name: {buyerName}</span>
//                     {/*<span className="country-region text-secondary d-block text-uppercase">type: {type}</span>*/}
//                     <span className="country-region text-secondary d-block text-uppercase">Date: {moment(date).format("MMM DD,YYYY")}</span>
//                     <span className="country-region text-secondary d-block text-uppercase">Topic: Travel</span>
//                     <span className="country-region text-secondary d-block text-uppercase">Goes to detail page</span>
//
//                     {type === 'history' ?
//                     <span>
//                         <button style={{"position": "absolute", "right": "5px", "bottom" : "5px"}}> Review </button>
//                     </span>
//                         :
//                     <span>
//                         <button style={{"position": "absolute", "right": "180px", "bottom" : "5px"}}> Chat </button>
//                         <button style={{"position": "absolute", "right": "5px", "bottom" : "5px"}}> Cancel / Reschedule </button>
//                     </span>
//                     }
//
//                 </div>
//
//             </div>
//         </div>
//     )
// }
//
// 이거는 prop이 있는지, 그리고 string이 맞는지 이런거 체크하는 것으로 꼭 필요한 것은 아님
// Card.propTypes = {
//     // user: PropTypes.shape({
//     //     name: PropTypes.shape({
//     //         official: PropTypes.string.isRequired
//     //     }).isRequired
//     // }).isRequired,
//     schedule: PropTypes.shape({
//         date: PropTypes.string.isRequired,
//         buyerName: PropTypes.string.isRequired
//     }).isRequired,
//
//     type: PropTypes.shape({
//         type: PropTypes.string.isRequired,
//     }).isRequired,
// };

// function mapStateToProps(store) {
//     return {};
// }

// export default Card;
function mapStateToProps(store) {
    return {
        user: store.auth.user,
        // isAuthenticated: store.auth.isAuthenticated
    };
}


export default withRouter(connect(mapStateToProps)(Card));
